import { render, staticRenderFns } from "./CurrentProductsScatter.vue?vue&type=template&id=bd7a6e84&"
import script from "./CurrentProductsScatter.vue?vue&type=script&lang=js&"
export * from "./CurrentProductsScatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports